<template>
    <div>
		<div class="row">
			<div class="col">

				<div class="d-flex justify-content-end">
					<div class="filter-bar loadable "  :class="{ 'loading' : loading_sign_ups }">
						<div><strong>Sign ups</strong></div>

						<div class="completion-bar small-bar">
							<div v-bind:style="{ width: ((sign_ups.active / 100) * 100) + '%' }"></div>
							<span>{{ ((sign_ups.active / 100) * 100).toFixed(0) + '%' }}</span>
						</div>
					</div>
					
					<div class="filter-bar loadable" :class="{ 'loading' : loading_completed_course }" v-show="show_progress_bar">
						<div><strong>Completed course</strong></div>
					    
					    <div class="completion-bar small-bar">
							<div v-bind:style="{ width: ((completed_course.completed / 100) * 100) + '%' }"></div>
							<span>{{ ((completed_course.completed / 100) * 100).toFixed(0) + '%' }}</span>
						</div>
					</div>
				</div>
			    
			</div>
		</div>
    </div>
</template>
<script>
export default {
	props:['sign_ups','loading_sign_ups','loading_completed_course','show_progress_bar','completed_course','agency','AgencyView'],
	created : function(){
		console.log(this.sign_ups)
	}
}
</script>


// WEBPACK FOOTER //
// src/components/shared/SignUpProgressBar.vue